import styled from 'styled-components';

export const TeamCalendarWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.mainColor};
`;



// WEBPACK FOOTER //
// ./src/containers/TeamCalendarWidget/styles.js